import { AugmentationToolbarOption } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import { useCanViewSimpleNav } from "../../unified-home/useCanViewUnifiedHome"
import { useNotificationsState } from "../state/notification-state"
import NotificationAugmentation, {
  NotificationsControls
} from "./NotificationAugmentation"
import NotificationDigestSettingsAugmentation from "./NotificationDigestSettingsAugmentation"

function useNotificationsAugmentationToolbarOption(): AugmentationToolbarOption | null {
  const { unreadCount } = useNotificationsState()

  if (useCanViewSimpleNav()) {
    return {
      key: "notifications",
      icon: "bell-fill",
      indicator: unreadCount > 0,
      label: "Your Notifications",
      AugmentationComponent: NotificationAugmentation,
      AugmentationNavComponent: NotificationsControls,
      children: [
        {
          key: "settings",
          label: "Settings",
          AugmentationComponent: NotificationDigestSettingsAugmentation
        }
      ]
    }
  }

  return null
}

export default useNotificationsAugmentationToolbarOption
